(() => {
  const pauseIcon = `
    <svg class="icon icon-pause" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Pause video</title>
      <g id="Group 256">
        <rect id="Rectangle 88" x="9" y="9" width="26" height="26" rx="3.9569" stroke="white" stroke-width="2"/>
        <rect id="Rectangle 89" x="16" y="14" width="4.26087" height="15.8261" rx="1" fill="white"/>
        <rect id="Rectangle 90" x="23.2609" y="14" width="4.26087" height="15.8261" rx="1" fill="white"/>
      </g>
    </svg>
  `

  const playIcon = `
    <svg class="icon icon-play" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>play video</title>
      <g id="Property 1=play">
        <rect id="Rectangle 88" x="9" y="9" width="26" height="26" rx="3.9569" stroke="white" stroke-width="2"/>
        <path id="Rectangle 89" d="M16 15.7999V28.2207C16 29.0008 16.8535 29.4805 17.5199 29.075L27.6118 22.9328C28.2483 22.5454 28.2528 21.6231 27.6202 21.2295L17.5283 14.9508C16.8621 14.5364 16 15.0154 16 15.7999Z" fill="white"/>
      </g>
    </svg>
  `

  class FactoriesMillsDetails extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.style.height = 0;
      this.template = this.querySelector('template').content.cloneNode(true);
      this.content = this.querySelector('[data-content]');

      this.templateContent = this.template.querySelector('script').innerHTML;

      this.factoryMillDetailOpenHandler = this.openView.bind(this);
      this.factoryMillDetailCloseHandler = this.closeView.bind(this);
      this.videoToggleHandler = this.toggleMediaReproduction.bind(this);
      this.wheelScrollHandler = this.onWheelScroll.bind(this);
      this.closeViewHandler = this.closeView.bind(this);
      this.toggleMapHandler = this.toggleMap.bind(this);
      this.clickHandler = this.handleClick.bind(this);

      document.addEventListener('factoryMillDetail:open', this.factoryMillDetailOpenHandler)
      document.addEventListener('factoryMillDetail:close', this.factoryMillDetailCloseHandler)
      this.addEventListener('wheel', this.wheelScrollHandler);
      this.addEventListener('click', this.clickHandler);
    }

    handleClick(evt) {
      this.toggleMediaReproduction.call(this, evt);
      if(evt.target.closest('[data-close-view]')) {
        this.closeView();
      }
      this.toggleMap.call(this, evt);
      this.openFactoryView.call(this, evt);
    }

    openView(data) {
      if(this.data) {
        this.showSourceCard(this.data);
      }
      this.hideSourceCard(data.detail.factoryData);

      this.data = data.detail.factoryData;
      this.updateContent(data.detail.factoryData);

      window.scrollTo({
        top: this.parentElement.offsetTop - 150,
        behavior: "smooth",
      })

      if(this.isOpen == false) {
        this.addEventListener('transitionend', () => {
          this.classList.add('is-open');
          this.style.height = "auto";
          this.hideSourceCard(data.detail.factoryData);
          this.isOpen = true;
        }, {once: true})

        this.style.height = this.scrollHeight + "px";
      } else {
        this.style.height = "auto";
        this.hideSourceCard(data.detail.factoryData);
      }
    }

    closeView() {
      if(!this.data || this.className.indexOf('is-open') == -1) return;

      this.showSourceCard(this.data);
      this.style.height = this.scrollHeight + "px";

      this.addEventListener('transitionend', () => {
        this.classList.remove('is-open');
        this.isOpen = false;
      }, {
        once: true
      })

      setTimeout(() => {
        this.style.height = 0;
      }, 50);
    }

    buildSrcSet(image) {
      if (!image) return '';

      const sizes = [48, 85, 90, 112, 256, 320, 480, 640, 750, 828, 1080, 1200, 1920, 2048, 3840];
      const srcset = sizes.map((size) => {
        return `${image}${image.indexOf('?') > -1 ? '&' : '?'}width=${size} ${size}w`
      })

      return srcset.join(',');
    }

    buildFeaturedMedia(media) {
      if (media.type == "video") {
        const container = document.createElement('div');
        container.classList.add('featured-media__video-container', 'is-playing');
        container.setAttribute('data-video-container', '');
        const tag = document.createElement("video");
        const content = media.sources.map((source) => {
          const sourceTag = document.createElement("source");
          sourceTag.src = source.src;
          sourceTag.type = `video/${source.format}`;

          return sourceTag;
        });
        tag.classList.add("featured-media__video");
        tag.poster = media.poster;
        tag.autoplay = true;
        tag.loop = true;
        tag.playsInline = true;
        tag.muted = true;
        tag.append(...content);

        const controlButton = document.createElement('button');
        controlButton.classList.add('featured-media__control-button');
        controlButton.innerHTML = playIcon + pauseIcon;

        container.appendChild(tag);
        container.appendChild(controlButton);

        return container;
      } else {
        const tag = document.createElement("img");
        tag.src = media.src;
        tag.srcset = this.buildSrcSet(media.src);
        tag.sizes = "(max-width:992px) 40vw, 100vw";
        tag.classList.add('featured-media__image');

        return tag;
      }
    }

    buildInfoCards(cardsData) {
      const cardTemplate = `
        <li class="information-card">
          <img class="information-card__icon" src="\${iconImage}" width="44px" height="44px" alt="">
          <h3 class="information-card__title">\${cardTitle}</h3>
          <p class="information-card__blurb">\${cardBlurb}</p>
        </li>
      `
      const cards = cardsData.map((data) => {
        let updatedCard = cardTemplate;
        updatedCard = updatedCard.replace("${iconImage}", data.icon);
        updatedCard = updatedCard.replace("${cardTitle}", data.title);
        updatedCard = updatedCard.replace("${cardBlurb}", data.blurb);

        return updatedCard;
      })

      return cards.join(" ");
    }

    buildMapCards(cardsData) {
      const cards = cardsData.map((card, index) => {
        const cardNode = document.createElement('button');
        cardNode.setAttribute('data-map-card', card.handle);
        cardNode.type = "button";
        cardNode.classList.add('map-card');
        if(index == 0) {
          cardNode.classList.add('is-visible');
        }

        const imageNode = document.createElement('img');
        imageNode.src = card.image.src;
        imageNode.srcset = this.buildSrcSet(card.image.src);
        imageNode.alt = !!card.image.alt ? card.image.alt : "";
        imageNode.classList.add('map-card__image');

        cardNode.append(imageNode);

        if(card.label) {
          const labelNode = document.createElement('span');
          labelNode.classList.add('map-card__label', 'label');
          labelNode.innerText = card.label;
          cardNode.append(labelNode);
        }

        return cardNode.outerHTML;
      })
      let cardsString = cards.join('');
      if(cards.length > 1) {
        cardsString += `
          <div class="map-information-buttons">
            <button type="button" class="map-information-button map-information-button__previous" disabled data-map-toggle="-1">
              <svg class="icon icon-caret" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Previous map</title>
                <path d="M6.83203 13.416L1.21745 6.99935L6.83203 0.582683" stroke="currentColor"/>
              </svg>
            </button>

            <button type="button" class="map-information-button map-information-button__next" data-map-toggle="+1">
              <svg class="icon icon-caret" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Next Map</title>
                <path d="M6.83203 13.416L1.21745 6.99935L6.83203 0.582683" stroke="currentColor"/>
              </svg>
            </button>
          </div>
        `;
      }

      return cardsString;
    }

    async updateContent(data) {
      const featuredMedia = this.buildFeaturedMedia(data.featured_media);
      const infoCards = this.buildInfoCards(data.information_cards);
      const mapsCards = this.buildMapCards(data.map_info);
      let featuredShotLink = "";

      if(data.featured_shot.link) {
        const featuredShotLinkObject = new URL(data.featured_shot.link);
        featuredShotLink = `${Shopify.routes.root}${featuredShotLinkObject.pathname.replace(/\/[a-z]{2}\//, '').replace(/\/[a-z]{2}-[a-z]{2}\//g, '')}`
      }

      let updatedContent = this.templateContent.replaceAll("${headerImageSrc}", data.header_image.src);
      updatedContent = updatedContent.replace("${headerColor}", data.header_color == "white" ? 'header-content--white' : '')
      updatedContent = updatedContent.replace("${headerImageSrcset}", this.buildSrcSet(data.header_image.src));
      updatedContent = updatedContent.replace("${headerImageAlt}", !!data.header_image.alt ? data.header_image.alt : "");
      updatedContent = updatedContent.replace("${headerTitle}", data.name || "");
      updatedContent = updatedContent.replace("${headerSubtitle}", data.excerpt || "");
      updatedContent = updatedContent.replace("${featuredMedia}", featuredMedia.outerHTML);
      updatedContent = updatedContent.replace("${featuredShotImageSrc}", data.featured_shot.src);
      updatedContent = updatedContent.replace("${featuredShotImageSrcset}", this.buildSrcSet(data.featured_shot.src));
      updatedContent = updatedContent.replace("${featuredShotImageAlt}", !!data.featured_shot.alt ? data.featured_shot.alt : '');
      updatedContent = updatedContent.replace("${featuredShotImageLabel}", data.featured_shot.label);
      updatedContent = updatedContent.replace("${featuredShotLink}", featuredShotLink.replaceAll('//', '/'));
      updatedContent = updatedContent.replace("${detailShotImageSrcset}", this.buildSrcSet(data.detail_shot.src));
      updatedContent = updatedContent.replace("${detailShotAlt}", !!data.detail_shot.alt ? data.detail_shot.alt : '');
      updatedContent = updatedContent.replace("${infoCards}", infoCards);
      updatedContent = updatedContent.replace("${mapCards}", mapsCards);

      if(data.collection_id) {
        updatedContent = updatedContent.replace("${productListTitle}", data.type == 'factory' ? 'Shop From the Factory' : `Shop ${data.name}`);
        await nostojs(async (api) => {
          const CollectionData = await api.search({
            products: {
              categoryId: String(data.collection_id),
              facets: ['*'],
              fields: ['name', 'price', 'listPrice', 'url', 'imageUrl', 'alternateImageUrls', 'customFields.key', 'customFields.value', 'tags1'],
              size: 12,
              from: 0,
            },
          }, {
            track: "category",
            redirect: true,
          })

          const productObjects = CollectionData.products.hits.map((product, index) => {
            const productUrlObject = new URL(product.url);

            productUrlObject.pathname = `${productUrlObject.pathname.replace(/\/[a-z]{2}(?:-[a-z]{2})?\//mgi, Shopify.routes.root)}`

            return `
              <li class="card-container">
               <div class="product-card__container">
                  <v3-product-card
                    class="skeleton-item"
                    data-url="${productUrlObject.toString()}"
                    data-hide-swatches="true"
                    data-hide-quick-view="true"
                    data-loading="${index <= 5 ? "eager": "lazy"}"
                  >
                  </v3-product-card>
                </div>
              </li>
            `
          })

          updatedContent = updatedContent.replace("${productList}", productObjects.join(''));

          this.content.innerHTML = "";
          this.content.innerHTML = updatedContent;

          const sliderContainer = this.content.querySelector('[data-product-list]')

          this.slider = window.tns({
            container: sliderContainer,
            gutter: 13,
            items: 1,
            slideBy: 1,
            loop: false,
            nav: false,
            responsive: {
              992: {
                slideBy: "page",
                items: 5,
                gutter: 20,
              }
            }
          })
        })
      } else {
        updatedContent = updatedContent.replace("${productListTitle}","");
        updatedContent = updatedContent.replace("${productList}", "");
        this.content.innerHTML = "";
        this.content.innerHTML = updatedContent;
      }
    }

    hideSourceCard(data) {
      const sourceCards = document.querySelectorAll(`[data-card]`);
      sourceCards.forEach((card) => {
        if(card.dataset.card == data.handle) {
          card.style.display = "none"
        } else {
          card.removeAttribute('style');
        }
      })
    }

    showSourceCard(data) {
      const sourceCard = document.querySelector(`[data-card="${data.handle}"]`);

      if(sourceCard) {
        sourceCard.removeAttribute('style');
      }
    }

    toggleMediaReproduction(evt) {
      const container = evt.target.closest('[data-video-container]');
      if(!container) return;

      const video = container.querySelector('video');
      if(container.className.indexOf('is-playing') > -1) {
        video.pause();
        container.classList.remove('is-playing');
      } else {
        video.play();
        container.classList.add('is-playing');
      }
    }

    onWheelScroll(evt) {
      if(evt.target.closest('[data-information-cards-container]') && evt.deltaY) {
        const target = this.querySelector('[data-information-cards-container]');
        let allowScroll = false;

        if(evt.deltaY > 0 && (target.scrollLeft < target.scrollWidth - target.offsetWidth)) {
          allowScroll = true;
        }

        if(evt.deltaY < 0 && target.scrollLeft > 0) {
          allowScroll = true;
        }

        if(allowScroll) {
          target.scrollLeft += evt.deltaY;
          evt.preventDefault();
        }
      }
    }

    toggleMap(evt) {
      const container = evt.srcElement.closest('.map-information-buttons');

      if(container) {
        const button = evt.srcElement.closest('[data-map-toggle]');
        const maps = Array.from(container.parentElement.querySelectorAll('[data-map-card]'));
        const toggleButtons = Array.from(container.querySelectorAll('[data-map-toggle]'));
        const activeIndex = maps.findIndex((map) => {
          return map.className.indexOf('is-visible') > -1;
        });
        const targetIndex = activeIndex + Number.parseInt(button.dataset.mapToggle);

        if(targetIndex == maps.length) return;
        if(targetIndex < 0) return;

        maps.forEach((map, index) => {
          if(index == targetIndex) {
            map.classList.add('is-visible');
          } else {
            map.classList.remove('is-visible');
          }
        });

        toggleButtons.forEach((button, index) => {
          button.disabled = false;

          if(
            targetIndex == maps.length - 1 && index == 1 ||
            targetIndex == 0 && index == 0
          ) {
            button.disabled = true;
          }
        })
      }
    }

    openFactoryView(evt) {
      const mapCard = evt.srcElement.closest('[data-map-card]');

      if(!mapCard) return;
      const factoryCard = document.querySelector(`[data-factory-handle="${mapCard.dataset.mapCard}"]`);
      const mapContainer = document.querySelector('factories-map');
      const mapWrapper = document.querySelector('#map-container');

      mapContainer.classList.add('map-expanded');

      document.querySelectorAll('[name="layout-selected"]').forEach((button) => {
        if(button.getAttribute('value') == 'factories') {
          button.checked = true;
          button.dispatchEvent(new Event('change', {bubbles: true}));
        } else {
          button.checked = false;
        }
      })

      mapContainer.addEventListener('transitionend', () => {
        factoryCard.dispatchEvent(new Event('mouseenter', {bubbles: true, cancelable: true}))
        mapWrapper.scrollIntoView({
          block: "end",
        })
      }, {
        once: true
      })
    }
  }

  if(!customElements.get('factory-mills-detail')) {
    customElements.define('factory-mills-detail', FactoriesMillsDetails)
  }
})()